/**
 * 
 */
export default class RestApi {
  auth = {
    login: (data) => $app.api.post([ 'admin/auth/login', ]).data(data).with('accesses'),
    info: () => $app.api.get([ 'admin/auth/info', ]),

  }
  
  files = {
    create: (data) => {
      const formData = new FormData()
      $n.each(data, (value, name) => {
        formData.append(name, value)
      })
      return $app.api.post([ 'files', ]).data(formData).config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
  }

  companies = {
    info: () => $app.api.get([ 'companies', ]),
    create: (data) => $app.api.post([ 'companies', ]).data(data),
    delete: (id) => $app.api.delete([ 'companies', id, ]),
    edit: (id, data) => $app.api.patch([ 'companies', id, ]).data(data),
    company: (id) => $app.api.get([ 'companies', id, ]),
    confirmPayment: (id, data) => $app.api.post([ 'companies-tariffs/companies*/do-payment', id, ]).data(data),
    historyPayments: (id) => $app.api.get([ 'companies-tariffs/companies*/payments', id, ]),
    updatePayment: (id, data) => $app.api.patch([ 'company-tariff-payments', id, ]).data(data),
    deletePayments: (id) => $app.api.delete([ 'company-tariff-payments', id, ]),
  }

  users = {
    info: () => $app.api.get([ 'admin/users', ]),
    create: (data) => $app.api.post([ 'admin/users', ]).data(data),
    user: (id) => $app.api.get([ 'admin/users', id, ]),
    delete: (id) => $app.api.delete([ 'admin/users', id, ]),
    edit: (id, data) => $app.api.patch([ 'admin/users', id, ]).data(data),
    editPass: (id, data) => $app.api.patch([ 'users*/password', id, ]).data(data),
  }

  roles = {
    roles: () => $app.api.get([ 'admin/auth/roles', ]),
    create: (data) => $app.api.post([ 'admin/auth/roles', ]).data(data),
    delete: (id) => $app.api.delete([ 'admin/auth/roles', id, ]),
  }

  positions = {
    info: () => $app.api.get([ 'admin/accesses', ]),
  }

  permits = {
    info: () => $app.api.get([ 'admin/auth/permits', ]),
  }

  tariffs = {
    info: (id) => $app.api.get([ 'tariffs*', id, ]),
    create: (data) => $app.api.post([ 'tariffs', ]).data(data),
    edit: (id, data) => $app.api.patch([ 'tariffs*', id, ]).data(data),
    delete: (id) => $app.api.delete([ 'tariffs*', id, ]),
    attach: (tariffId, companyId, data) => $app.api.post([ 'companies-tariffs/tariffs*/companies*/attach', tariffId, companyId, ]).data(data),
  }

  // Настройка КЭДО: библиотека мета-полей, поля компании, маршруты согласования, шаблоны документов
  kdo = {
    dictionaries: () => $app.api.get([ 'admin/kdo/dictionaries', ]),

    fields: (companyId) => companyId ?
      $app.api.get([ 'admin/companies*/kdo/meta-fields', companyId, ]) :
      $app.api.get([ 'admin/kdo/meta-fields', ]),
    createField: (companyId, data) => companyId ?
      $app.api.post([ 'admin/companies*/kdo/meta-fields', companyId, ]).data(data) :
      $app.api.post([ 'admin/kdo/meta-fields', ]).data(data),
    editField: (id, data) => $app.api.patch([ 'admin/kdo/meta-fields', id, ]).data(data),
    deleteField: (id) => $app.api.delete([ 'admin/kdo/meta-fields', id, ]),
    promoteField: (id) => $app.api.post([ 'admin/kdo/meta-fields*/promote', id, ]),

    users: (companyId) => $app.api.get([ 'admin/companies*/kdo/users', companyId, ]),

    approvalTemplates: (companyId) => $app.api.get([ 'admin/companies*/kdo/approval-templates', companyId, ]),
    createApprovalTemplate: (companyId, data) => $app.api.post([ 'admin/companies*/kdo/approval-templates', companyId, ]).data(data),
    editApprovalTemplate: (id, data) => $app.api.patch([ 'admin/kdo/approval-templates', id, ]).data(data),
    deleteApprovalTemplate: (id) => $app.api.delete([ 'admin/kdo/approval-templates', id, ]),

    documentTemplates: (companyId) => $app.api.get([ 'admin/companies*/kdo/document-templates', companyId, ]),
    createDocumentTemplate: (companyId, data) => $app.api.post([ 'admin/companies*/kdo/document-templates', companyId, ]).data(data),
    editDocumentTemplate: (id, data) => $app.api.patch([ 'admin/kdo/document-templates', id, ]).data(data),
    deleteDocumentTemplate: (id) => $app.api.delete([ 'admin/kdo/document-templates', id, ]),
    uploadTemplateFile: (companyId, file) => {
      const formData = new FormData()
      formData.append('file', file)
      return $app.api.post([ 'admin/companies*/kdo/template-files', companyId, ]).data(formData)
        .config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
    // типовые документы (каталог): список, правка, создание шаблона компании одним нажатием
    defaultTemplates: () => $app.api.get([ 'admin/kdo/default-templates', ]),
    createDefaultTemplate: (data) => $app.api.post([ 'admin/kdo/default-templates', ]).data(data),
    editDefaultTemplate: (id, data) => $app.api.patch([ 'admin/kdo/default-templates', id, ]).data(data),
    deleteDefaultTemplate: (id) => $app.api.delete([ 'admin/kdo/default-templates', id, ]),
    makeDefaultTemplate: (documentTemplateId, data) => $app.api
      .post([ 'admin/kdo/document-templates*/make-default', documentTemplateId, ]).data(data),
    uploadDefaultTemplateFile: (file) => {
      const formData = new FormData()
      formData.append('file', file)
      return $app.api.post([ 'admin/kdo/default-template-files', ]).data(formData)
        .config({ headers: { 'Content-Type': 'multipart/form-data', }, })
    },
    analyzeLibrary: (data) => $app.api.post([ 'admin/kdo/analyze', ]).data(data),
    companyDefaultTemplates: (companyId) => $app.api.get([ 'admin/companies*/kdo/default-templates', companyId, ]),
    createFromDefault: (companyId, defaultTemplateId, data) => $app.api
      .post([ 'admin/companies*/kdo/default-templates*', companyId, defaultTemplateId, ]).data(data),
    analyze: (companyId, data) => $app.api.post([ 'admin/companies*/kdo/analyze', companyId, ]).data(data),
  }
}
